<template>
  <div id="Big_data">
    <div class="font">
      <span class="introSubTitle"><b>智慧城市应用</b></span>
      <p class="textStyle">
      基于大数据时空信息云平台，建设了全国首个县级智慧城市-智慧老河口，通过手机信号、WIFI、手机定位、APP第三方应用获取用户的定位信息，形成基于位置大数据的活动图，大数据支撑城市管理，
        全面感知获取水电煤实时消耗统计、警情时间统计、空气污染度等实时数据动态监控与及时告警，让城市运营智能化。
        2016年正式上线运行之后，建设成本减少70%，运营成本减少30%，节约信息化建设资金约1000万，
        获得2017中国新型智慧城市优秀平台案例奖及2018年中欧绿色和智慧城市奖，建议湖北省政府作为典型智慧城市建设模式在全省推广。
      </p>
    </div>
    <img width="100%" src="@/assets/img/scientific/Smart_city.jpg" />
    <p class="img_figure">县级智慧城市时空信息云平台</p>
<!--    <img width="100%" src="@/assets/img/scientific/smartCity1.png" />-->
<!--    <p class="img_figure">政府应用</p>-->
<!--    <img width="100%" src="@/assets/img/scientific/smartCity2.png" />-->
<!--    <p class="img_figure">企业应用</p>-->
<!--    <img width="100%" src="@/assets/img/scientific/smartCity3.png" />-->
<!--    <p class="img_figure">个人应用</p>-->
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="less">
#Big_data {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #454545;
  }

}
</style>

